// cityAddressActions.js
import { searchCities, getStates, getLocaleInfo } from '../../services/cityAddressServices';
import { STOP_LOADING, START_LOADING } from './actionTypes';
import { searchZipCodes } from '../../services/cityAddressServices';


// actions/localeActions.js (or wherever you keep it)
export const searchCitiesAction = (
  query = '',
  stateCode = '',
  limit = 20,
  opts = {}            // <— NEW: options
) => async (dispatch, getState) => {
  const silent = !!opts.silent;

  try {
    if (!silent) dispatch({ type: START_LOADING, service: 'SEARCH_CITIES' });

    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await searchCities(query, stateCode, limit, token);

    if (!silent) dispatch({ type: STOP_LOADING, service: 'SEARCH_CITIES' });
    dispatch({ type: 'SEARCH_CITIES_SUCCESS', payload: response });
    return response;
  } catch (error) {
    if (!silent) dispatch({ type: STOP_LOADING, service: 'SEARCH_CITIES' });
    dispatch({
      type: 'SEARCH_CITIES_FAILURE',
      payload: error || 'City search failed. Please try again.',
    });
    throw error;
  }
};


// Get all states
export const getStatesAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'GET_STATES' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getStates(token);
    dispatch({ type: STOP_LOADING, service: 'GET_STATES' });
    dispatch({ type: 'GET_STATES_SUCCESS', payload: response });
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'GET_STATES' });
    dispatch({ type: 'GET_STATES_FAILURE', payload: error || 'States service failed. Please try again.' });
    throw error;
  }
};

// Get locale information
export const getLocaleInfoAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'GET_LOCALE' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getLocaleInfo(token);
    dispatch({ type: STOP_LOADING, service: 'GET_LOCALE' });
    dispatch({ type: 'GET_LOCALE_SUCCESS', payload: response });
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'GET_LOCALE' });
    dispatch({ type: 'GET_LOCALE_FAILURE', payload: error || 'Locale service failed. Please try again.' });
    throw error;
  }
};

// Legacy actions for backward compatibility
export const getCityAction = (city) => searchCitiesAction(city);


export const searchZipCodesAction = (query = '', limit = 20) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SEARCH_ZIPCODES' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await searchZipCodes(query, limit, token);
    dispatch({ type: STOP_LOADING, service: 'SEARCH_ZIPCODES' });
    dispatch({ type: 'SEARCH_ZIPCODES_SUCCESS', payload: response });
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'SEARCH_ZIPCODES' });
    dispatch({ type: 'SEARCH_ZIPCODES_FAILURE', payload: error });
    throw error;
  }
};
